import { instance } from '@/services/avik-api-gateway'
import { DeviationDelay } from '@/types/deviation-delay'
import { AxiosResponse } from 'axios'

export function deleteDeviationDelay(
  deviationDelayUuid: string
): Promise<AxiosResponse<DeviationDelay>> {
  return instance.delete(`/deviation-delay/${deviationDelayUuid}`)
}
